import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 公共接口
export default {
  // 上传文件
  upload(params) { 
    // const url =  baseURL + '/tbPic/modify';
    const url =  baseURL + '/tbPic/setUserPhoto';
    return url;
  },
  
  setPhoto(params) { // 上传头像
    const url =  baseURL + '/tbPic/setUserPhoto';
    return axios.post(url, qs.stringify(params));
  },
}


// WEBPACK FOOTER //
// ./src/api/common.js